"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_USER = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.UPDATE_USER = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        ...User\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        ...User\n      }\n    }\n  }\n  ", "\n"])), fragments_1.USER_FRAGMENT);
var templateObject_1;
